// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ImageCropper__changeProfilePhoto-d09c52 {
  flex: 1;
  background-color: #5b5b5b;
  justify-content: center;
  align-items: center;
  position: relative;
}

.ImageCropper__control-de2b4c {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  margin: 0 16px;
  position: relative;
  flex-shrink: 0;
}

.ImageCropper__button-be14a7 {
  position: absolute;
  inset-inline-end: 25px;
  top: 16px;
}

.ImageCropper__slider-da17f8 {
  width: 200px;
  height: 4px;
}

.ImageCropper__cropAreaRound-c5ae86 {
  border-radius: 50%;
}

.ImageCropper__cropAreaSquare-c22bc8 {
  border-radius: 26.67%;
}

.ImageCropper__changeProfilePhoto-d09c52 .ImageCropper__cropAreaCover-ed1253 {
  border-radius: 0;
  border: none;
}

.ImageCropper__coverCustomContainer-b6f359 {
  position: absolute;
  aspect-ratio: 1/1;
  width: 100%;
  top: 50%;
  transform: translateY(-50%);
  border: 1px dashed rgba(255, 255, 255, 0.7);
  display: flex;
  flex-direction: column;
  pointer-events: none;
  left: 0;
  box-sizing: border-box;
}

.ImageCropper__coverCustomRow-defbcb {
  flex: 1;
  pointer-events: none;
  padding: 7px;
  background: rgba(0, 0, 0, 0.5);
  color: var(--addition-50);
}

.ImageCropper__coverCustomRow-defbcb:nth-child(2) {
  background: none;
  border-top: 1px dashed rgba(255, 255, 255, 0.7);
  border-bottom: 1px dashed rgba(255, 255, 255, 0.7);
}

.ImageCropper__coverCustomText-d88c7e {
  font: var(--font-subtitle-3);
  letter-spacing: var(--font-spacing-subtitle-3);
  padding: 6px 8px;
  border-radius: 6px;
  background: rgba(51, 51, 51, 0.6);
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/ImageCropper/ImageCropper.styles.m.css"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,gBAAA;EACA,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,2CAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,OAAA;EACA,sBAAA;AACF;;AAEA;EACE,OAAA;EACA,oBAAA;EACA,YAAA;EACA,8BAAA;EACA,yBAAA;AACF;;AAEA;EACE,gBAAA;EACA,+CAAA;EACA,kDAAA;AACF;;AAEA;EACE,4BAAA;EACA,8CAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;AACF","sourcesContent":[".changeProfilePhoto {\n  flex: 1;\n  background-color: #5b5b5b;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n\n.control {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 48px;\n  margin: 0 16px;\n  position: relative;\n  flex-shrink: 0;\n}\n\n.button {\n  position: absolute;\n  inset-inline-end: 25px;\n  top: 16px;\n}\n\n.slider {\n  width: 200px;\n  height: 4px;\n}\n\n.cropAreaRound {\n  border-radius: 50%;\n}\n\n.cropAreaSquare {\n  border-radius: 26.67%;\n}\n\n.changeProfilePhoto .cropAreaCover {\n  border-radius: 0;\n  border: none;\n}\n\n.coverCustomContainer {\n  position: absolute;\n  aspect-ratio: 1 / 1;\n  width: 100%;\n  top: 50%;\n  transform: translateY(-50%);\n  border: 1px dashed rgba(255, 255, 255, 0.7);\n  display: flex;\n  flex-direction: column;\n  pointer-events: none;\n  left: 0;\n  box-sizing: border-box;\n}\n\n.coverCustomRow {\n  flex: 1;\n  pointer-events: none;\n  padding: 7px;\n  background: rgba(0, 0, 0, 0.5);\n  color: var(--addition-50);\n}\n\n.coverCustomRow:nth-child(2) {\n  background: none;\n  border-top: 1px dashed rgba(255, 255, 255, 0.7);\n  border-bottom: 1px dashed rgba(255, 255, 255, 0.7);\n}\n\n.coverCustomText {\n  font: var(--font-subtitle-3);\n  letter-spacing: var(--font-spacing-subtitle-3);\n  padding: 6px 8px;\n  border-radius: 6px;\n  background: rgba(51, 51, 51, 0.6);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"changeProfilePhoto": `ImageCropper__changeProfilePhoto-d09c52`,
	"control": `ImageCropper__control-de2b4c`,
	"button": `ImageCropper__button-be14a7`,
	"slider": `ImageCropper__slider-da17f8`,
	"cropAreaRound": `ImageCropper__cropAreaRound-c5ae86`,
	"cropAreaSquare": `ImageCropper__cropAreaSquare-c22bc8`,
	"cropAreaCover": `ImageCropper__cropAreaCover-ed1253`,
	"coverCustomContainer": `ImageCropper__coverCustomContainer-b6f359`,
	"coverCustomRow": `ImageCropper__coverCustomRow-defbcb`,
	"coverCustomText": `ImageCropper__coverCustomText-d88c7e`
};
module.exports = ___CSS_LOADER_EXPORT___;
